var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAuthNotAllowed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 152 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.56 16.1679C89.176 3.85595 62.824 3.85595 41.44 16.1679C20.056 28.4799 6.87996 51.3759 6.87996 75.9999C6.87996 100.624 20.056 123.52 41.44 135.832C62.824 148.144 89.176 148.144 110.56 135.832C131.944 123.52 145.12 100.624 145.12 75.9999C145.12 51.3759 131.944 28.4799 110.56 16.1679ZM113.8 10.5519C90.472 -3.05605 61.528 -3.05605 38.2 10.5519C14.872 24.16 0.399963 48.9999 0.399963 75.9999C0.399963 103 14.872 128.056 38.2 141.448C61.528 155.056 90.472 155.056 113.8 141.448C137.128 128.056 151.6 103 151.6 75.9999C151.6 48.9999 137.128 23.9439 113.8 10.5519Z",
    fill: "url(#paint0_linear_190_107)",
    stroke: "white",
    strokeWidth: 0.25,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M117.256 68.8721H34.744V82.9121H117.256V68.8721Z",
    fill: "url(#paint1_linear_190_107)",
    stroke: "white",
    strokeWidth: 0.2856,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_190_107",
    x1: 23.1912,
    y1: 123.749,
    x2: 128.369,
    y2: 28.648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#61ADFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFADFA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_190_107",
    x1: 51.3353,
    y1: 98.3016,
    x2: 100.459,
    y2: 53.884,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFADFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#61ADFA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuthNotAllowed);
export default __webpack_public_path__ + "static/media/auth_not_allowed.1772cbfa656a3a2965de1c8713dbc1c4.svg";
export { ForwardRef as ReactComponent };